import { render, staticRenderFns } from "./StockScoreDetailsTip.vue?vue&type=template&id=0813b838&scoped=true&"
import script from "./StockScoreDetailsTip.vue?vue&type=script&lang=js&"
export * from "./StockScoreDetailsTip.vue?vue&type=script&lang=js&"
import style0 from "./StockScoreDetailsTip.vue?vue&type=style&index=0&id=0813b838&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0813b838",
  null
  
)

export default component.exports